module.exports = __webpack_public_path__ + "static/media/collegelogo@2x.9167c282.png";